import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CCCheckbox from 'components/shared/DesignSystem/SlabTransferPortal/CCCheckbox';
import Text from 'components/shared/DesignSystem/SlabTransferPortal/Text';

const Row = styled.div`
  display: flex;
  padding: var(--cc_size_spacing_l);
  border-bottom: 1px solid var(--cc_color_border_default);
  cursor: pointer;
`;

const DetailsContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  pointer-events: none;
`;

const Title = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: -3px;
`;

const Description = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:empty {
    display: none;
  }
`;

const SelectableTemplateRow = ({
  id,
  title,
  description,
  isSelected,
  onSelect,
}) => {
  return (
    <Row
      key={id}
      onClick={(e) => {
        if (e.currentTarget !== e.target) return;
        onSelect(id);
      }}
    >
      <CCCheckbox checked={isSelected} onClick={() => onSelect(id)} id={id} />
      <DetailsContainer>
        <Title family="heading" weight="600" size="m" numberOfLines={1}>{title}</Title>
        <Description color="subtle" ccMargin="xxs none none">{description}</Description>
      </DetailsContainer>
    </Row>
  );
};

SelectableTemplateRow.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default SelectableTemplateRow;
